import React from 'react';
import TeaserCard, { TeaserCardProps } from './TeaserCard';

const TeaserCardFullImage = (props: TeaserCardProps) => (
  <TeaserCard
    {...props}
    {...(props.data.teaserImage && { variant: 'full-image' })}
  />
);

export default TeaserCardFullImage;
